/*
 * @Description  : 
 * @Author       : XiaoLei
 * @Date         : 2021-03-26 17:55:09
 * @LastEditTime : 2025-10-12 16:29:55
 * @LastEditors  : BigBigger
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    beforeEnter: (to ,from, next) => {
      sessionStorage.setItem('categoryName', '');
      next();
    },
    component: () => import(/* webpackChunkName: "course" */ '../views/course/index.vue')
  },
  {
    path: '/category/:id',
    name: 'jiangsu',
    beforeEnter: (to ,from, next) => {
      // 添加江苏后缀限制显示课程
      const categoryName = to.params.id;
      sessionStorage.setItem('categoryName', categoryName);
      next({
        name: 'Course'
      });
    },
  },
  {
    path: '/course',
    name: 'Course',
    component: () => import(/* webpackChunkName: "course" */ '../views/course/index.vue')
  },
  {
    path: '/course/signup',
    name: 'Signup',
    component: () => import(/* webpackChunkName: "Signup" */ '../views/course/signup/index.vue')
  },
  {
    path: '/course/signup/selectjob',
    name: 'selectjob',
    component: () => import(/* webpackChunkName: "selectjob" */ '../views/course/signup/selectjob.vue')
  },
  {
    path: '/course/signup/info',
    name: 'info',
    component: () => import(/* webpackChunkName: "info" */ '../views/course/signup/info.vue')
  },
  {
    path: '/course/signup/selectAddress',
    name: 'selectAddress',
    component: () => import(/* webpackChunkName: "selectAddress" */ '../views/course/signup/selectAddress.vue')
  },
  {
    path: '/course/signup/editAddress',
    name: 'editAddress',
    component: () => import(/* webpackChunkName: "editAddress" */ '../views/course/signup/editAddress.vue')
  },
  {
    path: '/course/signup/review',
    name: 'review',
    component: () => import(/* webpackChunkName: "review" */ '../views/course/signup/review.vue')
  },
  {
    path: '/course/signup/payFinish',
    name: 'payFinish',
    component: () => import(/* webpackChunkName: "payFinish" */ '../views/course/signup/payFinish.vue')
  },
  {
    path: '/course/class/:id',
    name: 'Play',
    component: () => import(/* webpackChunkName: "play" */ '../views/class/index.vue')
  },
  {
    path: '/course/protocol/:id',
    name: 'protocol',
    component: () => import(/* webpackChunkName: "protocol" */ '../views/course/protocol/Protocol.vue')
  },
  {
    path: '/course/:id',
    name: 'CourseDetail',
    component: () => import(/* webpackChunkName: "CourseDetail" */ '../views/course/courseDetail.vue')
  },
  {
    path: '/mini',
    name: 'Mini',
    component: () => import(/* webpackChunkName: "CourseDetail" */ '../views/mini/index.vue')
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import(/* webpackChunkName: "CourseDetail" */ '../views/pay.vue')
  },
 
  {
    path: '/mine/mineInfo',
    name: 'mineInfo',
    component: () => import(/* webpackChunkName: "mineInfo" */ '../views/mine/mineInfo/index.vue')
  },
  {
    path: '/mine/orderDetail',
    name: 'orderDetail',
    component: () => import(/* webpackChunkName: "orderDetail" */ '../views/mine/orderDetail/index.vue')
  },
  {
    path: '/mine/orderRefund/:orderId',
    name: 'orderRefund',
    component: () => import(/* webpackChunkName: "refund" */ '../components/mine/refund.vue')
  },
  {
    path: '/mine/protocolDetail',
    name: 'protocolDetail',
    component: () => import(/* webpackChunkName: "protocolDetail" */ '../views/mine/protocolDetail/index.vue')
  },
  {
    path: '/mine',
    name: 'Mine',
    component: () => import(/* webpackChunkName: "mine" */ '../views/mine/index.vue')
  },
  {
    path: '/lesson',
    name: 'Lesson',
    component: () => import(/* webpackChunkName: "mine" */ '../views/lesson/lesson.vue')
  },
  {
    path: '/lesson/:id',
    name: 'LessonDetail',
    component: () => import(/* webpackChunkName: "mine" */ '../views/lesson/courseDetail.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})
router.beforeEach((to, from, next) => {
  if(to.query.ysn && to.query.ysn.indexOf('?') !== -1) {
    let ysn = to.query.ysn
    ysn = ysn.slice(0,ysn.indexOf('?'))
    delete to.query.ysn
    next({
      path: to.path,
      query: {
        ysn: ysn,
        ...to.query
      }
    })
  }
  if (!to.query.ysn && from.query.ysn) {
    next({
      path: to.path,
      query: {
        ysn: from.query.ysn,
        ...to.query
      }
    });
  } else {
    next();
  }
});
// router.beforeEach((to, form, next) => {
//   if (to.query.categoryName !== undefined)
//     sessionStorage.setItem(
//       'categoryName',
//       to.query.categoryName,
//     );
//   next();
// })

export default router
